import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import '../CompanyAutoComplete.css';

// Props :
// dropdownList :: array => array of items to show in the dropdown
// dropdownValue :: string => Array list value name on which values showing in the dropdown
// searchTerm :: value => value on which dropdown will be filtered

class DynamicAutoComplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filternumbers(searchTerm),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
  }

  filternumbers = value => {
    const inputValue = value.trim().toLowerCase();
    const { dropdownList, dropdownValue } = this.props; // array of items to show
    return dropdownList?.filter(item => {
      if (dropdownValue) {
        return item[dropdownValue].toLowerCase().includes(inputValue);
      }
      if (typeof item === 'number')
        JSON.stringify(item)
          .toLowerCase()
          .includes(inputValue);
      else return item.toLowerCase().includes(inputValue);
    });
  };

  getNumberValue = item => {
    const { dropdownValue } = this.props; // array of items to show
    if (dropdownValue) {
      return item[dropdownValue];
    }
    return item;
  };

  renderSuggestion = item => {
    const { dropdownValue } = this.props; // array of items to show
    if (dropdownValue) {
      return <div>{item[dropdownValue]}</div>;
    }
    return <div>{item}</div>;
  };

  onChange = (event, { newValue }) => {
    const { dropdownValue, onKeyDown } = this.props;
    console.log('onChange', newValue);
    if (newValue && onKeyDown)
      onKeyDown([newValue]);
    if (newValue === '' || newValue === undefined) {
      this.props.onChange({
        name: dropdownValue ? dropdownValue : newValue,
        value: null,
        suggestion: null,
      });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filternumbers(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  onNumberSelected = (ev, { suggestion, suggestionValue }) => {
    console.log('onNumberSelected', suggestion, suggestionValue);
    const { dropdownValue } = this.props;
    const evObj = { name: dropdownValue, value: suggestionValue, suggestion };
    this.props.onChange(evObj);
  };

  onKeyPress = e => {
    const { dropdownList, userAutocomplete, dropdownValue } = this.props;
    if (e.key === 'Enter' && dropdownValue) {
      let suggestion = dropdownList.filter(item => item[dropdownValue] === e.currentTarget.value);
      this.props.onChange({
        name: dropdownValue,
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  render() {
    const { searchTerm, suggestions } = this.state;
    const { dropdownValue } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Number...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: dropdownValue || 'dynamicDropdown',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getNumberValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onNumberSelected}
        />
      </div>
    );
  }
}

export default DynamicAutoComplete;
